import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=2747b414"
import script from "./Teams.vue?vue&type=script&lang=js"
export * from "./Teams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2747b414')) {
      api.createRecord('2747b414', component.options)
    } else {
      api.reload('2747b414', component.options)
    }
    module.hot.accept("./Teams.vue?vue&type=template&id=2747b414", function () {
      api.rerender('2747b414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/News/Teams.vue"
export default component.exports